const routes = {
  login: "/login",
  register: "/register",
  authenticatorSetup: "/authenticator-setup",
  companyDetails: "/company-details",
  municipalityDetails: "/municipality-details",
  companyForm: "/company-form",
  companyLocationForm: "/company-location-form",
  companyRelatedEntitiesForm: "/company-related-entities-form",
  "dashboard/company/reporting-year": "/dashboard/company/reporting-year",
  "dashboard/company/locations": "/dashboard/company/locations",
  "dashboard/company": "/dashboard/company",
  "dashboard/company/relatedEntities": "/dashboard/company/related-entities",
  "dashboard/municipality/directory": "/dashboard/municipality/directory",
  "dashboard/municipality/progress": "/dashboard/municipality/progress",
  "dashboard/municipality/appAdoption": "/dashboard/municipality/app-adoption",
  "dashboard/impact": "/dashboard/impact",
  "dashboard/wallet": "/dashboard/wallet",
  dashboard: "/dashboard",
  climate: "/dashboard/climate",
  climateSetup: "/dashboard/climate/setup",
  "dashboard/results": "/dashboard/results",
  "dashboard/accounting": "/dashboard/accounting",
  "dashboard/reports": "/dashboard/reports",
  "dashboard/scope1/fugitiveCombustion": "/dashboard/scope-1/fugitive-combustion",
  "dashboard/scope1/mobileCombustion": "/dashboard/scope-1/mobile-combustion",
  "dashboard/scope1": "/dashboard/scope-1",
  "dashboard/scope1/stationaryCombustion": "/dashboard/scope-1/stationary-combustion",
  "dashboard/scope2": "/dashboard/scope-2/energy",
  "dashboard/scope2/eac": "/dashboard/scope-2/eac",
  "dashboard/scope2/re-gen": "/dashboard/scope-2/re-gen",
  "dashboard/scope3": "/dashboard/scope-3",
  "dashboard/scope3/upstreamActivities": "/dashboard/scope-3/upstream-activities",
  "dashboard/scope3/downstreamActivities": "/dashboard/scope-3/emissionsData",
  "dashboard/shortTerm": "/dashboard/short-term",
  "dashboard/longTerm": "/dashboard/long-term",
  "dashboard/mitigation": "/dashboard/mitigation",
  "dashboard/netZero": "/dashboard/net-zero",
  "dashboard/reductionPlan": "/dashboard/reduction-plan",
  "dashboard/campaign-manager": "/dashboard/campaign-manager",
  "dashboard/campaign-manager/mupi": "/dashboard/campaign-manager/mupi",
  "dashboard/campaign-manager/app": "/dashboard/campaign-manager/app",
  "dashboard/campaign-manager/booking": "/dashboard/campaign-manager/booking",
  "dashboard/campaign-manager/booking/select": "/dashboard/campaign-manager/booking/select",
  "dashboard/campaign-manager/booking/content": "/dashboard/campaign-manager/booking/content",
  "dashboard/campaign-manager/booking/review": "/dashboard/campaign-manager/booking/review",
  "dashboard/campaign-manager/booking/payment": "/dashboard/campaign-manager/booking/payment",
  "dashboard/campaign-manager/booking/payment/status": "/dashboard/campaign-manager/booking/payment/status",
  "dashboard/campaign-manager/campaign-payment": "/dashboard/campaign-manager/campaign-payment",
  "dashboard/campaign-manager/confirm-payment": "/dashboard/campaign-manager/confirm-payment",
  "dashboard/campaign-manager/campaign-overview": "/dashboard/campaign-manager/campaign-overview",
  "dashboard/campaigns": "/dashboard/campaigns",
  "dashboard/content-studio": "/dashboard/content-studio",
  "dashboard/analytics": "/dashboard/analytics",
  "dashboard/climateWebsite": "/dashboard/climate-website",
  "dashboard/notifications": "/dashboard/notifications",
  "dashboard/settings/notifications": "/dashboard/settings/notifications",
  "dashboard/settings/security": "/dashboard/settings/security",
  addEac: "/add-eac",
  fugitiveEmissions: "/fugitive-emissions",
  machinery: "/machinery",
  notFound: "/not-found",
  roadVehicle: "/road-vehicle",
  stationaryCombustion: "/stationary-combustion",
}

export default routes
